export const SET_FINANCING_MENU_STATE = 'SET_FINANCING_MENU_STATE';
export const SET_MOBILE_MENU_STATE = 'SET_MOBILE_MENU_STATE';
export const INITIALIZE_HAAP = 'INITIALIZE_HAAP';
